import ProfileStatsBlock from "../../../../components/profileStatsBlock/profileStatsBlock";
import { connect } from "react-redux";
export default connect(state => ({ data: state.attendance.poorPerformers }))(ProfileStatsBlock);
